import { fork, all } from 'redux-saga/effects';
import appSagas from 'store/app/sagas';
import oauthSagas from 'store/oauth/sagas';
import usuariosSaga from 'store/usuarios/sagas';
import practicasSaga from 'store/practicas/sagas';
import cursosSaga from 'store/cursos/sagas';
import informesSaga from 'store/informes/sagas';
import photosSaga from 'store/photos/sagas';

const allSagas = [
  appSagas,
  oauthSagas,
  usuariosSaga,
  practicasSaga,
  cursosSaga,
  informesSaga,
  photosSaga,
];

// start all sagas in parallel
export default function* rootSaga() {
  yield all(allSagas.map((saga) => fork(saga)));
}
